import { useMemo } from 'react'
import { AiDisclosureBadge, Prose } from '@azoya-spa/ui'
import LegalPage from './LegalPage'
import { TexteLegal } from './TexteLegal'
import { compterSections, decouperSectionIa } from './contenuLegal'
import { useSiteContentState } from '../../hooks/useSiteContent'

const FALLBACK = {
  title: 'Mentions légales',
  bodyMarkdown: 'Contenu momentanément indisponible.',
}

const LEAD =
  'Qui édite ce site, qui l’héberge, comment nous joindre — et ce que nous devons à l’intelligence artificielle.'

/**
 * La section « transparence IA » sort du fil du texte pour recevoir son propre
 * panneau : c'est le seul endroit du site où l'engagement est énoncé en entier,
 * et la visiteuse doit pouvoir y reconnaître le signalement qu'elle a vu sur un
 * visuel — d'où le vrai `AiDisclosureBadge`, celui-là même qui s'affiche sur
 * les images. Le texte reste celui du back-office : le panneau donne la forme,
 * pas le fond.
 */
function PanneauIa({ titre, corps }) {
  return (
    <section className="LegalPage-panneau-ia" aria-labelledby="transparence-ia">
      <div className="LegalPage-panneau-ia-entete">
        <div className="LegalPage-surtitre">Notre engagement</div>
        {/* L'amorce n'est pas décorative : le texte du panneau vient du
            back-office et dit « signalé sur le visuel concerné » sans pouvoir
            désigner ce badge. Sans elle, le signalement se lirait comme une
            affirmation sur le panneau lui-même, qui ne porte aucune image. */}
        <span className="LegalPage-panneau-ia-exemple">
          Sur un visuel, vous verrez <AiDisclosureBadge label="Image générée par IA" variant="caption" />
        </span>
      </div>
      <h2 id="transparence-ia">{titre}</h2>
      <Prose>
        <TexteLegal>{corps}</TexteLegal>
      </Prose>
    </section>
  )
}

function MentionsLegales() {
  const { data: page, status, reessayer } = useSiteContentState('legal/mentions-legales', FALLBACK)


  const indisponible = status === 'error' && page === FALLBACK
  const sections = useMemo(() => compterSections(page.bodyMarkdown), [page.bodyMarkdown])
  // `null` quand la gérante a renommé le titre au point qu'on ne le reconnaît
  // plus : le contenu s'affiche alors d'un seul tenant, sans panneau.
  const decoupe = useMemo(() => decouperSectionIa(page.bodyMarkdown), [page.bodyMarkdown])

  return (
    <LegalPage
      title={page.title}
      lead={LEAD}
      meta={sections ? `${sections} sections` : null}
      sibling={{ href: '/cgu', label: "Conditions générales d'utilisation" }}
      indisponible={indisponible}
      onReessayer={reessayer}
    >
      {decoupe ? (
        <>
          {decoupe.avant && (
            <Prose>
              <TexteLegal>{decoupe.avant}</TexteLegal>
            </Prose>
          )}
          <PanneauIa titre={decoupe.ia.titre} corps={decoupe.ia.corps} />
          {decoupe.apres && (
            <Prose>
              <TexteLegal>{decoupe.apres}</TexteLegal>
            </Prose>
          )}
        </>
      ) : (
        <Prose>
          <TexteLegal>{page.bodyMarkdown}</TexteLegal>
        </Prose>
      )}
    </LegalPage>
  )
}

export default MentionsLegales
